<template>
<div class="container">
     <br class="hidden-sm hidden-xs">
    <h2 class="text-center hidden-xs"> <i class="fa fa-address-card-o"></i> Sitter Profile Setup</h2>
    
    <h4 style="margin-bottom:5px; margin-top:5px;" class="text-center hidden-sm hidden-md hidden-lg"> <i class="fa fa-address-card-o"></i> Sitter Profile Setup</h4>
    
    <div style="margin-bottom:10px;"  v-sticky="{ zIndex: 4, stickyTop: 1 }" class="progress" id="progress">
        <div class="progress-bar" role="progressbar" :style="{width: profileStatus.CompletePct + '%'}" :class= "{'progress-bar-warning': !profileStatus.IsProfileReady, 'progress-bar-info': profileStatus.IsProfileReady}">
            <span> {{profileStatus.CurrentStatus}} <i v-if="!profileStatus.IsProfileReady" @click="showPopup()" class="fa fa-question-circle" style="font-size:14px;color:#8f47a4"></i></span>
            
        </div>
    </div>
    
  
  <ul class="nav nav-tabs hidden-xs">
    <router-link  active-class="active" tag="li" to="/sitter-profile-edit/about">
        <a>About Me</a>
    </router-link>

    <router-link  active-class="active" tag="li" to="/sitter-profile-edit/petpreferences">
        <a>Pet Preferences</a>
    </router-link>

    <router-link active-class="active" tag="li" to="/sitter-profile-edit/servicerates">
        <a>Service Rates</a>
    </router-link>


   <router-link active-class="active" tag="li" to="/sitter-profile-edit/calendar">
        <a>Calendar</a>
    </router-link>
   
  </ul>

   <ul class="nav nav-tabs hidden-sm hidden-md hidden-lg">
    
    <router-link active-class="active" tag="li" to="/sitter-profile-edit/about">
        <a>About</a>
    </router-link>

    <router-link  active-class="active" tag="li" to="/sitter-profile-edit/petpreferences">
        <a>Prefs</a>
    </router-link>

    <router-link active-class="active" tag="li" to="/sitter-profile-edit/servicerates">
        <a>Rates</a>
    </router-link>


   <router-link active-class="active" tag="li" to="/sitter-profile-edit/calendar">
        <a>Calendar</a>
    </router-link>

    
  </ul>
        
        <router-view></router-view>
        
    </div>
  </div>
</div>


</template>

<script>

import VueSticky from 'vue-sticky'

import Vue from 'vue'
import sitterApi from '../../services/sitterApi'
import router from '../../router'
import auth from '../../auth'
import store from '../../data/store'
import commonApi from '../../services/commonApi'


export default {
    name: 'profile',
    directives: {
        'sticky': VueSticky
    },
    data() {
        return {
              profileStatus: {
                 CompletePct: 0,
                 CurrentStatus: 'Loading',
                 IsProfileReady: false
              }      

        }
        
    },
        updated(){
        //    $zopim(function (){
        //       $zopim.livechat.sendVisitorPath();
        //   });
           $('[data-toggle="popover"]').popover();
    },
    methods: {
        updateProfileStatus(){
            var self = this;
            sitterApi.getSitterProfileStatus().then(function(data){
                self.profileStatus = data
                }).fail(function (error){
                    console.log(error)
                })
                
        },
        showPopup: function(){
            var self = this
            swal({
                title: "Profile Status",
                text: "This is an indicator of your profile status, complete all required fields or go to Dashboard to see whats missing in your profile",
                type: "success",
                showCancelButton: true,
                confirmButtonClass: 'btn-success',
                confirmButtonText: "Go Dashboard",
                cancelButtonClass: 'btn-info',
                cancelButtonText: "Keep me here",
                closeOnConfirm: true,
                html: true
            }, function(){
                self.$router.push({path: '/dashboard/feedback-performance'})
            });
        
            
        }
        
    },
    created: function () {
        var self = this
        if (!store.getters.authenticated && !localStorage.getItem('access_token')) {
            console.log("am here not authenticated")
            router.push({ path: '/login', query: { redirect: 'sitter-profile-edit' } })
        }
        else
        {
          
            
        }
        
    }, 
    watch: {
        '$route': function(){ //workaround to keep Edit Profile as active for child routes. needs to be applied here and in mounted.
            if (router.currentRoute.fullPath=='/sitter-profile-edit')
                        router.push({path: 'sitter-profile-edit/about/'})
                    
        }
    },
    mounted: function () {
        var self = this
        this.$ga.page(this.$router)
        sitterApi.getSitterProfileStatus().then(function(data){
                self.profileStatus = data
        }).fail(function (error){
            console.log(error)
        })
        

        if (router.currentRoute.fullPath=='/sitter-profile-edit')  //workaround to keep Edit Profile as active for child routes.
                    router.push({path: 'sitter-profile-edit/about/'})
       

        if (!store.getters.authenticated && !localStorage.getItem('access_token')) {
            console.log("am here redirecting to profile-edit")
            router.push({ path: '/login', query: { redirect: 'sitter-profile-edit' } })
        }
        else
        {
          
        }


        
    },
  

}

</script>


<style scoped>

.progress {
    position: relative;
}

.progress span {
    position: absolute;
    display: block;
    width: 100%;
    color: #3c3b3b;
 }

</style>


// WEBPACK FOOTER //
// SitterProfileEdit.vue?7580f63c